// @ts-nocheck
import action from 'utils/actionCreators';

export const GET_PERMISSION_ROLE_REQUEST =
  'Varicon/@src/app/Dashboard/UserManagement/GET_PERMISSION_ROLE_REQUEST';
export const GET_PERMISSION_ROLE_SUCCESS =
  'Varicon/@src/app/Dashboard/UserManagement/GET_PERMISSION_ROLE_SUCCESS';
export const GET_PERMISSION_ROLE_FAILURE =
  'Varicon/@src/app/Dashboard/UserManagement/GET_PERMISSION_ROLE_FAILURE';

export const GET_ALL_USERS_REQUEST =
  'Varicon/@src/app/Dashboard/UserManagement/GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS =
  'Varicon/@src/app/Dashboard/UserManagement/GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAILURE =
  'Varicon/@src/app/Dashboard/UserManagement/GET_ALL_USERS_FAILURE';

export const ADD_USER_REQUEST =
  'Varicon/@src/app/Dashboard/UserManagement/ADD_USER_REQUEST';
export const ADD_USER_SUCCESS =
  'Varicon/@src/app/Dashboard/UserManagement/ADD_USER_SUCCESS';
export const ADD_USER_FAILURE =
  'Varicon/@src/app/Dashboard/UserManagement/ADD_USER_FAILURE';

export const GET_USER_BY_ID_REQUEST =
  'Varicon/@src/app/Dashboard/UserManagement/GET_USER_BY_ID_REQUEST';
export const GET_USER_BY_ID_SUCCESS =
  'Varicon/@src/app/Dashboard/UserManagement/GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAILURE =
  'Varicon/@src/app/Dashboard/UserManagement/GET_USER_BY_ID_FAILURE';

export const UPDATE_USER_BY_ID_REQUEST =
  'Varicon/@src/app/Dashboard/UserManagement/UPDATE_USER_BY_ID_REQUEST';
export const UPDATE_USER_BY_ID_SUCCESS =
  'Varicon/@src/app/Dashboard/UserManagement/UPDATE_USER_BY_ID_SUCCESS';
export const UPDATE_USER_BY_ID_FAILURE =
  'Varicon/@src/app/Dashboard/UserManagement/UPDATE_USER_BY_ID_FAILURE';

export const UPDATE_USER_STATUS_REQUEST =
  'Varicon/@src/app/Dashboard/UserManagement/UPDATE_USER_STATUS_REQUEST';
export const UPDATE_USER_STATUS_SUCCESS =
  'Varicon/@src/app/Dashboard/UserManagement/UPDATE_USER_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_FAILURE =
  'Varicon/@src/app/Dashboard/UserManagement/UPDATE_USER_STATUS_FAILURE';

export const DELETE_USER_REQUEST = 'USERS/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'USERS/DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'USERS/DELETE_USER_FAILURE';

export const OPEN_CONFIRMATION_MODAL = 'USERS/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'USERS/CLOSE_CONFIRMATION_MODAL';

export const FILTER_USERS = 'USERS/FILTER_USERS';

export const getPermissionRoleRequest = action(GET_PERMISSION_ROLE_REQUEST);
export const getPermissionRoleSuccess = action(GET_PERMISSION_ROLE_SUCCESS);
export const getPermissionRoleFailure = action(GET_PERMISSION_ROLE_FAILURE);

export const getAllUsersRequest = action(GET_ALL_USERS_REQUEST, 'payload');
export const getAllUsersSuccess = action(GET_ALL_USERS_SUCCESS);
export const getAllUsersFailure = action(GET_ALL_USERS_FAILURE);

export const addUserRequest = action(ADD_USER_REQUEST, 'payload');
export const addUserSuccess = action(ADD_USER_SUCCESS);
export const addUserFailure = action(ADD_USER_FAILURE);

export const getUserByIdRequest = action(GET_USER_BY_ID_REQUEST, 'id');
export const getUserByIdSuccess = action(GET_USER_BY_ID_SUCCESS);
export const getUserByIdFailure = action(GET_USER_BY_ID_FAILURE);

export const updateUserByIdRequest = action(
  UPDATE_USER_BY_ID_REQUEST,
  'id',
  'payload',
);
export const updateUserByIdSuccess = action(UPDATE_USER_BY_ID_SUCCESS);
export const updateUserByIdFailure = action(UPDATE_USER_BY_ID_FAILURE);

export const updateUserStatusRequest = action(UPDATE_USER_STATUS_REQUEST, 'id');
export const updateUserStatusSuccess = action(UPDATE_USER_STATUS_SUCCESS);
export const updateUserStatusFailure = action(UPDATE_USER_STATUS_FAILURE);

export const filterUsers = action(FILTER_USERS, 'payload');

export const deleteUserRequest = action(DELETE_USER_REQUEST, 'payload');

export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);
